import { createContext } from 'react';

type Theme = {
  theme: 'dark' | 'light';
  isDarkMode: boolean;
  toggleTheme: () => void;
};

const ThemeContext = createContext<Theme>({
  theme: 'light',
  isDarkMode: false,
  toggleTheme: () => null
});

export default ThemeContext;
